import { render, staticRenderFns } from "./companySummary.vue?vue&type=template&id=129af510&"
import script from "./companySummary.vue?vue&type=script&lang=js&"
export * from "./companySummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports